module.exports = __webpack_public_path__ + "img/icon_tourism_teij.f380e0ac.png";